import { useSelector } from 'react-redux'
import ContactLifeCycleActivitySelectors from 'modules/domain/contactLifeCycleActivity/selectors'
import { Progress, ResourceHook } from 'modules/types'
import ContactLifeCycleActivityActions from 'modules/domain/contactLifeCycleActivity/duck'
import {
  ContactLifeCycleActivity,
  ContactLifeCycleActivityListRequestFilter,
} from 'modules/domain/contactLifeCycleActivity/types'
import { useAction, useDidMount, usePageQuery } from '@agro-club/frontend-shared'

export const useContactLifeCycleActivityList: ResourceHook<
  ContactLifeCycleActivity[],
  [{ filter?: ContactLifeCycleActivityListRequestFilter; pageSize?: number }]
> = ({ filter, pageSize }: { filter?: ContactLifeCycleActivityListRequestFilter; pageSize?: number } = {}) => {
  const progress = useSelector(ContactLifeCycleActivitySelectors.listFetchProgress)
  const list = useSelector(ContactLifeCycleActivitySelectors.contactLifeCycleActivityList)
  const page = usePageQuery()
  const params: { filter?: ContactLifeCycleActivityListRequestFilter; page?: number; pageSize?: number } = {}
  if (filter) params.filter = filter
  if (page) params.page = page
  if (pageSize !== undefined) params.pageSize = pageSize
  const filterUpdated = useAction(ContactLifeCycleActivityActions.filterUpdated)
  const fetchAction = useAction(ContactLifeCycleActivityActions.listRequested, page ? { page } : {})

  useDidMount(() => {
    if (filter) {
      filterUpdated(filter)
    }
    if (progress !== Progress.SUCCESS) {
      fetchAction()
    }
  })

  return [progress, list]
}

export const useContactLifeCycleActivity: ResourceHook<ContactLifeCycleActivity, [string]> = (id: string) => {
  const meta = useSelector((state) => ContactLifeCycleActivitySelectors.meta(state, id))
  const contactLifeCycleActivity = useSelector((state) =>
    ContactLifeCycleActivitySelectors.contactLifeCycleActivity(state, id),
  )
  const fetchAction = useAction(ContactLifeCycleActivityActions.itemRequested, id)

  useDidMount(() => {
    if (!contactLifeCycleActivity || contactLifeCycleActivity.id !== id) {
      fetchAction()
    }
  })

  return [meta.fetchProgress, contactLifeCycleActivity]
}
